import React from 'react';
import { createRoot } from 'react-dom/client';
import './mobile.css';
import App from './App';
import { zigbeeConfig } from './config/zigbee';

// Dynamically update the PWA manifest name with the tenant display name.
// Runs fire-and-forget so it never blocks rendering.
(function updatePwaManifest() {
    const savedToken = localStorage.getItem('iot_token') ?? '';
    fetch(`${zigbeeConfig.apiBaseUrl}/tenant/info`, {
        headers: {
            'X-Tenant-Id': zigbeeConfig.tenantId,
            ...(savedToken ? { Authorization: `Bearer ${savedToken}` } : {}),
        },
    })
        .then(r => r.ok ? r.json() : null)
        .then(info => {
            if (!info?.display_name) return;
            const link = document.querySelector<HTMLLinkElement>('link[rel="manifest"]');
            if (!link) return;
            return fetch('/manifest.json')
                .then(r => r.json())
                .then(base => {
                    const updated = {
                        ...base,
                        name: `DevIoT - ${info.display_name}`,
                        short_name: info.display_name,
                    };
                    const blob = new Blob([JSON.stringify(updated)], { type: 'application/manifest+json' });
                    link.href = URL.createObjectURL(blob);
                });
        })
        .catch(() => {});
})();

const container = document.getElementById('root');
if (container) {
  const root = createRoot(container);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(err => {
      console.warn('Service worker registration failed:', err);
    });
  });
}